export const BATTERY_ALIASES = Object.freeze(["battery", "batteryPercent", "batteryLevel"]);
export const VOLTAGE_ALIASES = Object.freeze(["voltage", "externalVoltage", "batteryVoltage"]);

export const toFiniteTelemetryValue = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : null;
};

export const pickTelemetryValue = (sources = [], aliases = []) => {
  for (const source of sources) {
    for (const alias of aliases) {
      const numeric = toFiniteTelemetryValue(source?.[alias]);
      if (numeric !== null) return numeric;
    }
  }
  return null;
};

// This is the UI contract for telemetry returned by the API and socket stream.
// Keep every screen on these canonical names rather than device-specific aliases.
export const getNormalizedTelemetry = (sources = []) => ({
  battery: pickTelemetryValue(sources, BATTERY_ALIASES),
  voltage: pickTelemetryValue(sources, VOLTAGE_ALIASES),
});

export const formatBatteryDisplay = (sources = []) => {
  const telemetry = getNormalizedTelemetry(sources);
  if (telemetry.battery !== null) return `${telemetry.battery}%`;
  if (telemetry.voltage !== null) return `${telemetry.voltage} V`;
  return 'N/A';
};
